import DefaultLayout from "./containers/DefaultLayout";
import AssetSchemas from "./views/AssetSchemas/AssetSchemas/AssetSchemas";
import Dashboard from "./views/Dashboard";
import AddSchema from "./views/AssetSchemas/AssetSchemas/AddSchema/AddSchema";
import EditSchema from "./views/AssetSchemas/AssetSchemas/EditSchema/EditSchema";
import FinancicalStructure from "./views/FinancicalStructure/FinancicalStructure/FinancicalStructure";
import Seasonability from "./views/Seasonability/Seasonability/FinancicalStructure";
import {Projects} from "./views/Projects";
import {Dealroom} from "./views/Dealroom";
import DealroomView from "./views/Dealroom/Dealroom/DealroomView";

const routes = [
  { path: "/", name: "Home", component: DefaultLayout, exact: true },
  { path: "/dashboard", name: "Dashboard", component: Dashboard },
  {
    path: "/asset-schemas",
    name: "Asset Schemas",
    component: AssetSchemas,
    exact: true
  },
  {
    path: "/asset-schemas/add-schema",
    name: "Add Schema",
    component: AddSchema
  },
  {
    path: "/asset-schemas/edit-schema/:id",
    name: "Edit Schema",
    component: EditSchema
  },
  {
    path: "/financical-structure",
    name: "Financical Structure",
    component: FinancicalStructure,
    exact: true
  },
  {
    path: "/seasonability",
    name: "seasonability",
    component: Seasonability
  },
  {
    path: "/projects",
    name: "projects",
    component: Projects
  },
  {
    path: "/dealroom",
    name: "dealroom",
    component: Dealroom
  },
  {
    path: "/dealroom-view/:id",
    name: "dealroom-view",
    component: DealroomView
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js